import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import BerechtigungUtil from '../../services/BerechtigungUtil'
import VNBService from '../Verteilnetzbetreiber/VNBService'
import VNBDto from '../Verteilnetzbetreiber/VNBDto'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'
import './VNBStammdaten'
import './VNBBenutzer'

export default class VNBDetail extends WebComponent {

  constructor() {
    super()
    this.vnbService = new VNBService()
  }

  get translationFile() {
    return './views/VNBDetail/i18n.json'
  }

  get subsites() {
    return {
      VNBStammdaten: {
        render: () => html`<eko-frontend-vnb-detail-stammdaten .verteilnetzbetreiber="${this.verteilnetzbetreiber}"></eko-frontend-vnb-detail-stammdaten>`
      },
      VNBBenutzer: {
        render: () => html`<eko-frontend-vnb-detail-benutzer .verteilnetzbetreiber="${this.verteilnetzbetreiber}"></eko-frontend-vnb-detail-benutzer>`
      },
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    if(getNavigationId() === undefined) {
      navigate({ to: getNavigationHash(), id: new BerechtigungUtil().getActiveProfile().vnbExtId })
      return
    }
    Promise.resolve(
      this.vnbService.read(getNavigationId())
    ).then(json => {
      this.verteilnetzbetreiber = new VNBDto(json)
      this.render()
    })
  }

  getTemplate() {
    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.verteilnetzbetreiber.name}">
      </isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
    `
  }

  _getNavItems = () => {
    return [{
      text: this.i18n.translate('vnb.stammdaten.title'),
      icon: 'stream',
      url: `${Navigation.ROUTES.vnbStammdaten.url}/${getNavigationId()}`,
      suburls: [Navigation.ROUTES.vnbStammdaten.url]
    }, {
      text: this.i18n.translate('vnb.benutzer.title'),
      icon: 'user friends',
      url: `${Navigation.ROUTES.vnbBenutzer.url}/${getNavigationId()}`,
      suburls: [Navigation.ROUTES.vnbBenutzer.url]
    }]
  }
}

customElements.define('eko-frontend-vnb-detail', VNBDetail)
